export const TERMS_OF_USE_LINK = "https://classsolver.com/customer-terms/"
export const PRIVACY_POLICY_LINK = "https://classsolver.com/privacy-policy/"
export const POWERSCHOOL_INTEGRATION_INSTRUCTIONS =
  "https://classsolverbau.blob.core.windows.net/public/PowerSchool Plugin.pdf"
export const CLEVER_INTEGRATION_INSTRUCTIONS =
  "https://classsolverbau.blob.core.windows.net/public/Clever_Integration.pdf"
export const CLASSLINK_INTEGRATION_INSTRUCTIONS =
  "https://classsolverbau.blob.core.windows.net/public/ClassLink_Integration.pdf"
